import { UIComponent } from "../../components";

export class ModalAccordions extends UIComponent {
    init() {
        this.activeAccordionItem;
        this.btnCloseSidebar.on("click", this.hide.bind(this));
    
    }

    getAccordionItemById(id) {
        let item;

        if (!this.items?.length) {
            return item;
        }

        findItem: for (let i = 0; i < this.items.length; i++) {
            const { items = [] } = this.items[i];

            for (let k = 0; k < items.length; k++) {
                if (items[k].attr("data-item-id") == id) {
                    item = items[k];
                    break findItem;
                }
            }
        }
        return item;
    }

    changeActiveAccordionItem(id) {
        this.clearActiveItem();
        const item = this.getAccordionItemById(id);

        item?.addClass("active");
        this.activeAccordionItem = item;
    }

    clearActiveItem() {
        if (this.activeAccordionItem)
            this.activeAccordionItem.removeClass("active");
    }

    getAccordionById(id) {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].id === id) {
                return this.items[i];
            }
        }
    }

    getActiveAccordion() {
        return this.items.find((tbx) => tbx.isActive);
    }

    addAccordionItemDirectly(templateData) {
        const accordionBody = this.find( ".modal-ai-templates__accordion-body" );
        if (!accordionBody) {
            return;
        }

        const itemHTML = `
        <button class="modal-ai-templates__accordion-body-item" 
                data-item-id="${templateData.prompt.id}" 
                data-tbx-name="items[]">
            <span data-tbx-bind="tplName">${templateData.prompt.title || ""}</span>
        </button>
    `;

        accordionBody.insertAdjacentHTML("beforeend", itemHTML);
    }

    show() {
        this.addClass("visible");
    }

    hide() {
        this.removeClass("visible");
    }

    onActive(cb) {
        this.on("activeAccordion", ({ detail }) => cb(detail.id));
    }
}
